module.exports = __webpack_public_path__ + "static/img/yingjijiuyuan.7d8b98c5.png";